/**
 * Non-secret identity slice held in the NgRx store. The bearer access token itself does NOT
 * belong here -- it lives in {@link AccessTokenHolder} so it cannot ride along with metareducers,
 * devtools, or any other state-tree pump into persistent or observable channels.
 */
export interface Auth {
  isAuthenticated: boolean;
  username: string;
  /** Given name from the token's `firstName` claim; `''` when the claim is absent. */
  firstName: string;
  /** Family name from the token's `lastName` claim; `''` when the claim is absent. */
  lastName: string;
  userId: number;
  roles: string[];
}

/**
 * Canonical "no session" {@link Auth} value. Used both as the NgRx initial state and as the
 * payload dispatched whenever the session is cleared (bootstrap wipe, logout, cross-tab logout).
 * Defined here so every consumer agrees on the empty shape -- avoids {@code {} as Auth} casts
 * that bypass strict-null typing and leave {@code isAuthenticated} undefined instead of false.
 */
export const EMPTY_AUTH: Auth = {
  isAuthenticated: false,
  username: '',
  firstName: '',
  lastName: '',
  userId: 0,
  roles: []
};

/** Bearer access token, kept in {@link AccessTokenHolder} (not in the store). */
export interface AuthToken {
  type: string;
  value: string;
}
